var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 64,
    viewBox: "0 0 44 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6667 21.3333C38.8267 21.3333 37.3333 22.8267 37.3333 24.6667V40H36C31.6 40 28 43.6 28 48H25.3333C25.3333 42.56 29.4133 38.08 34.6667 37.4133V8.66667C34.6667 6.82667 33.1733 5.33333 31.3333 5.33333C29.4933 5.33333 28 6.82667 28 8.66667V29.3333H25.3333V3.33333C25.3333 1.49333 23.84 0 22 0C20.16 0 18.6667 1.49333 18.6667 3.33333V29.3333H16V7.33333C16 5.49333 14.5067 4 12.6667 4C10.8267 4 9.33333 5.49333 9.33333 7.33333V32H6.66667V15.3333C6.66667 13.4933 5.17333 12 3.33333 12C1.49333 12 0 13.4933 0 15.3333V42C0 54.16 9.84 64 22 64C34.16 64 44 54.16 44 42V24.6667C44 22.8267 42.5067 21.3333 40.6667 21.3333Z",
    fill: "#EC5B71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.2386d23bc37fcde5037eee1f179ba176.svg";
export { ForwardRef as ReactComponent };